var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.className,attrs:{"id":"outs-ach"}},[_c('Title',{attrs:{"ch":"优秀成果","en":"outstanding achievement"}}),_c('act-dis')],1)}
var staticRenderFns = []

export { render, staticRenderFns }